/*
 * <gm-scorri>: pista orizzontale a scorrimento nativo (swipe su mobile) con frecce
 * da mouse. Le frecce compaiono solo se c'è qualcosa da scorrere e si disattivano
 * agli estremi. L'elemento attivo (aria-current) viene portato in vista all'avvio.
 */
class GmScorri extends HTMLElement {
  connectedCallback() {
    this.pista = this.querySelector('.gm-scorri__pista');
    this.prec = this.querySelector('.gm-scorri__freccia--prec');
    this.succ = this.querySelector('.gm-scorri__freccia--succ');
    if (!this.pista) return;

    this.aggiorna = this.aggiorna.bind(this);
    this.prec?.addEventListener('click', () => this.scorri(-1));
    this.succ?.addEventListener('click', () => this.scorri(1));
    this.pista.addEventListener('scroll', this.aggiorna, { passive: true });
    this.osservatore = new ResizeObserver(this.aggiorna);
    this.osservatore.observe(this.pista);

    const attivo = this.pista.querySelector('[aria-current="page"]');
    if (attivo) {
      const voce = attivo.closest('li');
      this.pista.scrollLeft = voce.offsetLeft - this.pista.clientWidth / 2 + voce.clientWidth / 2;
    }
    this.aggiorna();
  }

  disconnectedCallback() {
    this.osservatore?.disconnect();
  }

  scorri(verso) {
    const ridotto = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.pista.scrollBy({ left: verso * this.pista.clientWidth * 0.8, behavior: ridotto ? 'auto' : 'smooth' });
  }

  aggiorna() {
    const { scrollLeft, scrollWidth, clientWidth } = this.pista;
    const scorrevole = scrollWidth > clientWidth + 2;
    if (this.prec) {
      this.prec.hidden = !scorrevole;
      this.prec.disabled = scrollLeft <= 2;
    }
    if (this.succ) {
      this.succ.hidden = !scorrevole;
      this.succ.disabled = scrollLeft + clientWidth >= scrollWidth - 2;
    }
  }
}

if (!customElements.get('gm-scorri')) customElements.define('gm-scorri', GmScorri);
